webpackJsonp([195451945045015],{

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var trim = __webpack_require__(86)
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	/* Parse comma-separated tokens to an array. */
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = trim(input.slice(lastIndex, index))
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	/* Compile an array to comma-separated tokens.
	 * `options.padLeft` (default: `true`) pads a space left of each
	 * token, and `options.padRight` (default: `false`) pads a space
	 * to the right of each token. */
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  /* Ensure the last empty entry is seen. */
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return trim(values.join(right + comma + left))
	}


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(620);
	var foreach = __webpack_require__(251);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),

/***/ 252:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(252);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(253);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(86);
	var paramCase = __webpack_require__(597);
	var information = __webpack_require__(626);
	var spaces = __webpack_require__(639);
	var commas = __webpack_require__(167);
	var nan = __webpack_require__(440);
	var is = __webpack_require__(640);
	
	module.exports = wrapper;
	
	function wrapper(h, node, prefix) {
	  var r;
	  var v;
	
	  if (typeof h !== 'function') {
	    throw new Error('h is not a function');
	  }
	
	  r = react(h);
	  v = vdom(h);
	
	  if (prefix === null || prefix === undefined) {
	    prefix = r === true || v === true ? 'h-' : false;
	  }
	
	  if (is('root', node)) {
	    if (node.children.length === 1 && is('element', node.children[0])) {
	      node = node.children[0];
	    } else {
	      node = {
	        type: 'element',
	        tagName: 'div',
	        properties: {},
	        children: node.children
	      };
	    }
	  } else if (!is('element', node)) {
	    throw new Error('Expected root or element, not `' + ((node && node.type) || node) + '`');
	  }
	
	  return toH(h, node, {
	    prefix: prefix,
	    key: 0,
	    react: r,
	    vdom: v,
	    hyperscript: hyperscript(h)
	  });
	}
	
	/* Transform a HAST node through a hyperscript interface
	 * to *anything*! */
	function toH(h, node, ctx) {
	  var selector = node.tagName;
	  var properties;
	  var attributes;
	  var children;
	  var property;
	  var elements;
	  var length;
	  var index;
	  var value;
	
	  properties = node.properties;
	  attributes = {};
	
	  for (property in properties) {
	    addAttribute(attributes, property, properties[property], ctx);
	  }
	
	  if (ctx.vdom === true) {
	    selector = selector.toUpperCase();
	  }
	
	  if (ctx.hyperscript === true && attributes.id) {
	    selector += '#' + attributes.id;
	    delete attributes.id;
	  }
	
	  if ((ctx.hyperscript === true || ctx.vdom === true) && attributes.className) {
	    selector += '.' + spaces.parse(attributes.className).join('.');
	    delete attributes.className;
	  }
	
	  if (typeof attributes.style === 'string') {
	    /* VDOM expects a `string` style in `attributes`
	     * See https://github.com/Matt-Esch/virtual-dom/blob/947ecf9/
	     * docs/vnode.md#propertiesstyle-vs-propertiesattributesstyle */
	    if (ctx.vdom === true) {
	      if (!attributes.attributes) {
	        attributes.attributes = {};
	      }
	
	      attributes.attributes.style = attributes.style;
	      delete attributes.style;
	    /* React only accepts `style` as object. */
	    } else if (ctx.react === true) {
	      attributes.style = parseStyle(attributes.style);
	    }
	  }
	
	  if (ctx.prefix) {
	    ctx.key++;
	    attributes.key = ctx.prefix + ctx.key;
	  }
	
	  elements = [];
	  children = node.children || [];
	  length = children.length;
	  index = -1;
	
	  while (++index < length) {
	    value = children[index];
	
	    if (is('element', value)) {
	      elements.push(toH(h, value, ctx));
	    } else if (is('text', value)) {
	      elements.push(value.value);
	    }
	  }
	
	  /* Ensure no React warnings are triggered for
	   * void elements having children passed in. */
	  return elements.length === 0 ? h(selector, attributes) : h(selector, attributes, elements);
	}
	
	/* Add `name` and its `value` to `props`. */
	function addAttribute(props, name, value, ctx) {
	  var info = information(name) || {};
	  var subprop;
	
	  /* Ignore nully, `false`, `NaN`, and falsey known
	   * booleans. */
	  if (
	    value === null ||
	    value === undefined ||
	    value === false ||
	    nan(value) ||
	    (info.boolean && !value)
	  ) {
	    return;
	  }
	
	  if (info.name) {
	    name = info.name;
	  } else if (ctx.react && !paramCasedReactProp(name)) {
	    name = camelCase(name);
	  } else {
	    name = paramCase(name);
	  }
	
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    /* Accept `array`.  Most props are space-separater. */
	    value = (info.commaSeparated ? commas : spaces).stringify(value);
	  }
	
	  /* Treat `true` and truthy known booleans. */
	  if (info.boolean && ctx.hyperscript === true) {
	    value = '';
	  }
	
	  if (info.name !== 'class' && (info.mustUseAttribute || !info.name)) {
	    if (ctx.vdom === true) {
	      subprop = 'attributes';
	    } else if (ctx.hyperscript === true) {
	      subprop = 'attrs';
	    }
	
	    if (subprop) {
	      if (props[subprop] === undefined) {
	        props[subprop] = {};
	      }
	
	      props[subprop][name] = value;
	
	      return;
	    }
	  }
	
	  props[info.propertyName || name] = value;
	}
	
	/* Check if `h` is `react.createElement`.  It doesn’t accept
	 * `class` as an attribute, it must be added through the
	 * `selector`. */
	function react(h) {
	  var node = h && h('div');
	  return Boolean(node && ('_owner' in node || '_store' in node) && node.key === null);
	}
	
	/* Check if `h` is `hyperscript`.  It doesn’t accept
	 * `class` as an attribute, it must be added through the
	 * `selector`. */
	function hyperscript(h) {
	  return Boolean(h && h.context && h.cleanup);
	}
	
	/**
	 * Check if `h` is `virtual-dom/h`.  It’s the only
	 * hyperscript “compatible” interface needing `attributes`. */
	function vdom(h) {
	  try {
	    return h('div').type === 'VirtualNode';
	  } catch (err) { /* Empty */ }
	
	  /* istanbul ignore next */
	  return false;
	}
	
	function parseStyle(value) {
	  var result = {};
	  var declarations = value.split(';');
	  var length = declarations.length;
	  var index = -1;
	  var declaration;
	  var prop;
	  var pos;
	
	  while (++index < length) {
	    declaration = declarations[index];
	    pos = declaration.indexOf(':');
	    if (pos !== -1) {
	      prop = camelCase(trim(declaration.slice(0, pos)));
	      result[prop] = trim(declaration.slice(pos + 1));
	    }
	  }
	
	  return result;
	}
	
	function paramCasedReactProp(name) {
	  var head = name.slice(0, 4);
	  return (head === 'data' || head === 'aria') && name.length > 4;
	}
	
	function camelCase(val) {
	  if (val.slice(0, 4) === '-ms-') {
	    val = 'ms-' + val.slice(4);
	  }
	
	  return val.replace(/-([a-z])/g, replace);
	}
	
	function replace($0, $1) {
	  return $1.toUpperCase();
	}


/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	'use strict';
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	module.exports = function isNaN(value) {
		return value !== value;
	};


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(115);
	
	var implementation = __webpack_require__(123);
	var getPolyfill = __webpack_require__(124);
	var shim = __webpack_require__(441);
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	define(implementation, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = implementation;


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(123);
	
	module.exports = function getPolyfill() {
		if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
			return Number.isNaN;
		}
		return implementation;
	};


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(115);
	var getPolyfill = __webpack_require__(124);
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	module.exports = function shimNumberIsNaN() {
		var polyfill = getPolyfill();
		define(Number, { isNaN: polyfill }, { isNaN: function () { return Number.isNaN !== polyfill; } });
		return polyfill;
	};


/***/ }),

/***/ 597:
/***/ (function(module, exports) {

	'use strict';
	var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;
	var REVERSE_REGEX = /-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g;
	
	module.exports = exports = function kebabCase(str) {
		return str.replace(KEBAB_REGEX, function (match) {
			return '-' + match.toLowerCase();
		});
	};
	
	exports.reverse = function (str) {
		return str.replace(REVERSE_REGEX, function (match) {
			return match.slice(1).toUpperCase();
		});
	};


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(621);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),

/***/ 626:
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = getPropertyInformation;
	
	/* Constants. */
	var USE_ATTRIBUTE = 0x1;
	var USE_PROPERTY = 0x2;
	var BOOLEAN_VALUE = 0x8;
	var NUMERIC_VALUE = 0x10;
	var POSITIVE_NUMERIC_VALUE = 0x20 | 0x10;
	var OVERLOADED_BOOLEAN_VALUE = 0x40;
	var SPACE_SEPARATED = 0x80;
	var COMMA_SEPARATED = 0x100;
	
	/* Map of properties. Names are camel-cased properties. */
	var propertyConfig = {
	  /* Standard Properties. */
	  abbr: null,
	  accept: COMMA_SEPARATED,
	  acceptCharset: SPACE_SEPARATED,
	  accessKey: SPACE_SEPARATED,
	  action: null,
	  allowFullScreen: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  allowTransparency: USE_ATTRIBUTE,
	  alt: null,
	  /* https://html.spec.whatwg.org/#attr-link-as */
	  as: null,
	  async: BOOLEAN_VALUE,
	  autoComplete: SPACE_SEPARATED,
	  autoFocus: BOOLEAN_VALUE,
	  autoPlay: BOOLEAN_VALUE,
	  capture: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  cellPadding: null,
	  cellSpacing: null,
	  challenge: USE_ATTRIBUTE,
	  charSet: USE_ATTRIBUTE,
	  checked: USE_PROPERTY | BOOLEAN_VALUE,
	  cite: null,
	  /* To set className on SVG elements, it's necessary to
	   * use .setAttribute; this works on HTML elements too
	   * in all browsers except IE8. */
	  className: USE_ATTRIBUTE | SPACE_SEPARATED,
	  cols: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  colSpan: null,
	  command: null,
	  content: null,
	  contentEditable: null,
	  contextMenu: USE_ATTRIBUTE,
	  controls: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://github.com/WICG/controls-list/blob/gh-pages/explainer.md */
	  controlsList: SPACE_SEPARATED,
	  coords: NUMERIC_VALUE | COMMA_SEPARATED,
	  crossOrigin: null,
	  /* For `<object />` acts as `src`. */
	  data: null,
	  dateTime: USE_ATTRIBUTE,
	  default: BOOLEAN_VALUE,
	  defer: BOOLEAN_VALUE,
	  dir: null,
	  dirName: null,
	  disabled: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  download: OVERLOADED_BOOLEAN_VALUE,
	  draggable: null,
	  dropzone: SPACE_SEPARATED,
	  encType: null,
	  form: USE_ATTRIBUTE,
	  formAction: USE_ATTRIBUTE,
	  formEncType: USE_ATTRIBUTE,
	  formMethod: USE_ATTRIBUTE,
	  formNoValidate: BOOLEAN_VALUE,
	  formTarget: USE_ATTRIBUTE,
	  frameBorder: USE_ATTRIBUTE,
	  headers: SPACE_SEPARATED,
	  height: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  hidden: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  high: NUMERIC_VALUE,
	  href: null,
	  hrefLang: null,
	  htmlFor: SPACE_SEPARATED,
	  httpEquiv: SPACE_SEPARATED,
	  id: USE_PROPERTY,
	  inputMode: USE_ATTRIBUTE,
	  /* Web Components */
	  is: USE_ATTRIBUTE,
	  isMap: BOOLEAN_VALUE,
	  keyParams: USE_ATTRIBUTE,
	  keyType: USE_ATTRIBUTE,
	  kind: null,
	  label: null,
	  lang: null,
	  list: USE_ATTRIBUTE,
	  loop: USE_PROPERTY | BOOLEAN_VALUE,
	  low: NUMERIC_VALUE,
	  manifest: USE_ATTRIBUTE,
	  marginHeight: NUMERIC_VALUE,
	  marginWidth: NUMERIC_VALUE,
	  max: null,
	  maxLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  media: USE_ATTRIBUTE,
	  mediaGroup: null,
	  menu: null,
	  method: null,
	  min: null,
	  minLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  multiple: USE_PROPERTY | BOOLEAN_VALUE,
	  muted: USE_PROPERTY | BOOLEAN_VALUE,
	  name: null,
	  nonce: null,
	  noValidate: BOOLEAN_VALUE,
	  open: BOOLEAN_VALUE,
	  optimum: NUMERIC_VALUE,
	  pattern: null,
	  ping: SPACE_SEPARATED,
	  placeholder: null,
	  /* https://html.spec.whatwg.org/#attr-video-playsinline */
	  playsInline: BOOLEAN_VALUE,
	  poster: null,
	  preload: null,
	  /* https://html.spec.whatwg.org/#dom-head-profile */
	  profile: null,
	  radioGroup: null,
	  readOnly: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://html.spec.whatwg.org/#attr-link-referrerpolicy */
	  referrerPolicy: null,
	  /* `rel` is `relList` in DOM */
	  rel: SPACE_SEPARATED | USE_ATTRIBUTE,
	  required: BOOLEAN_VALUE,
	  reversed: BOOLEAN_VALUE,
	  role: USE_ATTRIBUTE,
	  rows: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  rowSpan: POSITIVE_NUMERIC_VALUE,
	  sandbox: SPACE_SEPARATED,
	  scope: null,
	  scoped: BOOLEAN_VALUE,
	  scrolling: null,
	  seamless: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  selected: USE_PROPERTY | BOOLEAN_VALUE,
	  shape: null,
	  size: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  sizes: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* https://html.spec.whatwg.org/#attr-slot */
	  slot: null,
	  sortable: BOOLEAN_VALUE,
	  sorted: SPACE_SEPARATED,
	  span: POSITIVE_NUMERIC_VALUE,
	  spellCheck: null,
	  src: null,
	  srcDoc: USE_PROPERTY,
	  srcLang: null,
	  srcSet: USE_ATTRIBUTE | COMMA_SEPARATED,
	  start: NUMERIC_VALUE,
	  step: null,
	  style: null,
	  summary: null,
	  tabIndex: NUMERIC_VALUE,
	  target: null,
	  title: null,
	  translate: null,
	  type: null,
	  typeMustMatch: BOOLEAN_VALUE,
	  useMap: null,
	  value: USE_PROPERTY,
	  volume: POSITIVE_NUMERIC_VALUE,
	  width: USE_ATTRIBUTE | NUMERIC_VALUE,
	  wmode: USE_ATTRIBUTE,
	  wrap: null,
	
	  /* Non-standard Properties. */
	
	  /* `autoCapitalize` and `autoCorrect` are supported in
	   * Mobile Safari for keyboard hints. */
	  autoCapitalize: null,
	  autoCorrect: null,
	  /* `autoSave` allows WebKit/Blink to persist values of
	   * input fields on page reloads */
	  autoSave: null,
	  /* `itemProp`, `itemScope`, `itemType` are for Microdata
	   * support. See http://schema.org/docs/gs.html */
	  itemProp: USE_ATTRIBUTE | SPACE_SEPARATED,
	  itemScope: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  itemType: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `itemID` and `itemRef` are for Microdata support as well
	   * but only specified in the the WHATWG spec document.
	   * See https://html.spec.whatwg.org/multipage/
	   * microdata.html#microdata-dom-api */
	  itemID: USE_ATTRIBUTE,
	  itemRef: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `property` is supported for OpenGraph in meta tags. */
	  property: null,
	  /* `results` show looking glass icon and recent searches
	   * on input search fields in WebKit/Blink */
	  results: null,
	  /* IE-only attribute that specifies security
	   * restrictions on an iframe as an alternative to the
	   * sandbox attribute on IE < 10 */
	  security: USE_ATTRIBUTE,
	  /* IE-only attribute that controls focus behavior */
	  unselectable: USE_ATTRIBUTE,
	
	  /* Ancient. */
	  xmlLang: USE_ATTRIBUTE,
	  xmlBase: USE_ATTRIBUTE
	};
	
	/* Map of properties to attributes.
	 * Names are lower-case properties.
	 * Values are HTML attributes. */
	var propertyToAttributeMapping = {
	  xmlbase: 'xml:base',
	  xmllang: 'xml:lang',
	  classname: 'class',
	  htmlfor: 'for',
	  httpequiv: 'http-equiv',
	  acceptcharset: 'accept-charset'
	};
	
	/* Expand config. */
	var information = {};
	var property;
	var name;
	var config;
	
	getPropertyInformation.all = information;
	
	for (property in propertyConfig) {
	  name = lower(property);
	  name = propertyToAttributeMapping[name] || name;
	  config = propertyConfig[property];
	
	  information[name] = {
	    name: name,
	    propertyName: property,
	    mustUseAttribute: check(config, USE_ATTRIBUTE),
	    mustUseProperty: check(config, USE_PROPERTY),
	    boolean: check(config, BOOLEAN_VALUE),
	    overloadedBoolean: check(config, OVERLOADED_BOOLEAN_VALUE),
	    numeric: check(config, NUMERIC_VALUE),
	    positiveNumeric: check(config, POSITIVE_NUMERIC_VALUE),
	    commaSeparated: check(config, COMMA_SEPARATED),
	    spaceSeparated: check(config, SPACE_SEPARATED)
	  };
	}
	
	/* Get a config for a property. */
	function getPropertyInformation(propertyName) {
	  var insensitive = lower(propertyName);
	
	  return information[propertyToAttributeMapping[insensitive] || insensitive];
	}
	
	/* Check a mask. */
	function check(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/* Lower-case a string. */
	function lower(value) {
	  return value.toLowerCase();
	}


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var has = __webpack_require__(437);
	var toH = __webpack_require__(438);
	
	/* Expose `rehype-react`. */
	module.exports = rehype2react;
	
	/**
	 * Attach a react compiler.
	 *
	 * @param {Unified} processor - Instance.
	 * @param {Object?} [options]
	 * @param {Object?} [options.components]
	 *   - Components.
	 * @param {string?} [options.prefix]
	 *   - Key prefix.
	 * @param {Function?} [options.createElement]
	 *   - `h()`.
	 */
	function rehype2react(options) {
	  var settings = options || {};
	  var createElement = settings.createElement;
	  var components = settings.components || {};
	
	  this.Compiler = compiler;
	
	  /* Compile HAST to React. */
	  function compiler(node) {
	    if (node.type === 'root') {
	      if (node.children.length === 1 && node.children[0].type === 'element') {
	        node = node.children[0];
	      } else {
	        node = {
	          type: 'element',
	          tagName: 'div',
	          properties: {},
	          children: node.children
	        };
	      }
	    }
	
	    return toH(h, node, settings.prefix);
	  }
	
	  /* Wrap `createElement` to pass components in. */
	  function h(name, props, children) {
	    var component = has(components, name) ? components[name] : name;
	    return createElement(component, props, children);
	  }
	}


/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var trim = __webpack_require__(86)
	
	exports.parse = parse
	exports.stringify = stringify
	
	var empty = ''
	var space = ' '
	var whiteSpace = /[ \t\n\r\f]+/g
	
	function parse(value) {
	  var input = trim(String(value || empty))
	  return input === empty ? [] : input.split(whiteSpace)
	}
	
	function stringify(values) {
	  return trim(values.join(space))
	}


/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),

/***/ 640:
/***/ (function(module, exports) {

	'use strict'
	
	/* eslint-disable max-params */
	
	/* Expose. */
	module.exports = is
	
	/* Assert if `test` passes for `node`.
	 * When a `parent` node is known the `index` of node */
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined
	  var hasIndex = index !== null && index !== undefined
	  var check = convert(test)
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node')
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node')
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index')
	  }
	
	  return Boolean(check.call(context, node, index, parent))
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	/* Utility assert each property in `test` is represented
	 * in `node`, and each values are strictly equal. */
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	/* Utility to convert a string into a function which checks
	 * a given node’s type for said string. */
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	/* Utility to return true. */
	function ok() {
	  return true
	}


/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(15);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// vendor utils
	// vendor
	var Slide = _react2.default.forwardRef(function (_ref, ref) {
	  var title = _ref.title,
	      image = _ref.image,
	      active = _ref.active,
	      width = _ref.width,
	      height = _ref.height;
	
	  var className = (0, _classnames2.default)('gallery__image', {
	    'gallery__image--is-active': active
	  });
	
	  var style = {
	    width: width + 'px',
	    height: height + 'px'
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'gallery__list-item', style: style },
	    _react2.default.createElement(_gatsbyImage2.default, {
	      sizes: image,
	      alt: title,
	      className: className,
	      ref: ref,
	      style: style
	    })
	  );
	});
	
	// vendor components
	
	
	Slide.propTypes = {
	  title: _propTypes2.default.string,
	  image: _propTypes2.default.shape({}).isRequired,
	  active: _propTypes2.default.boolean,
	  width: _propTypes2.default.string.isRequired,
	  height: _propTypes2.default.string.isRequired
	};
	
	Slide.defaultProps = {
	  title: '',
	  active: false
	};
	
	exports.default = Slide;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // vendor
	
	
	// vendor utils
	
	
	// Components
	
	
	// utils
	
	
	// styles
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Slide = __webpack_require__(139);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _utils = __webpack_require__(158);
	
	__webpack_require__(606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createSlidesArray = function createSlidesArray() {
	  var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var imageList = [].concat(images);
	
	  while (imageList.length < 7) {
	    var newImage = imageList.map(function (img) {
	      return _extends({}, img, {
	        id: img.id + '-clone' + (0, _utils.randomString)(),
	        active: false,
	        previous: false
	      });
	    });
	    imageList = [].concat(imageList, newImage);
	  }
	
	  return imageList;
	};
	
	var equilibrate = function equilibrate(array, index) {
	  var middle = Math.ceil((array.length - 1) / 2);
	  var result = array;
	
	  if (index < middle) {
	    var toMove = index - middle;
	    result = [].concat(array.slice(toMove), array.slice(0, toMove));
	  }
	
	  if (middle < index) {
	    var _toMove = index - middle;
	    result = [].concat(array.slice(_toMove), array.slice(0, _toMove));
	  }
	
	  return result;
	};
	
	var getOffsetWidthFromArray = function getOffsetWidthFromArray(array, id) {
	  var index = array.findIndex(function (_ref) {
	    var key = _ref.key;
	    return key === id;
	  });
	
	  return array.slice(0, index + 1).reduce(function (acc, cur) {
	    return acc + cur.props.width;
	  }, 0);
	};
	
	var setActive = function setActive(slides, id) {
	  return slides.map(function (slide) {
	    return _extends({}, slide, { active: slide.id === id });
	  });
	};
	
	var setPrevious = function setPrevious(slides, id) {
	  return slides.map(function (slide) {
	    return _extends({}, slide, { previous: slide.id === id });
	  });
	};
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery(props) {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    var images = props.images,
	        length = props.images.length;
	
	
	    _this.listWrapperRef = _react2.default.createRef();
	
	    var slides = createSlidesArray(images);
	
	    _this.state = {
	      slides: slides,
	      throttle: false,
	      length: length
	    };
	    return _this;
	  }
	
	  Gallery.prototype.componentDidMount = function componentDidMount() {
	    this.init();
	  };
	
	  Gallery.prototype.getActiveId = function getActiveId() {
	    var slide = this.state.slides.find(function (_ref2) {
	      var active = _ref2.active;
	      return active;
	    });
	
	    return slide ? slide.id : 0;
	  };
	
	  Gallery.prototype.getArrayIndex = function getArrayIndex(idToFind) {
	    return this.state.slides.findIndex(function (_ref3) {
	      var id = _ref3.id;
	      return id === idToFind;
	    });
	  };
	
	  Gallery.prototype.getDescription = function getDescription(idToFind) {
	    if (!idToFind) return '';
	
	    return this.state.slides.find(function (_ref4) {
	      var id = _ref4.id;
	      return id === idToFind;
	    }).description;
	  };
	
	  Gallery.prototype.getPositionById = function getPositionById(idToFind) {
	    var _state = this.state,
	        slides = _state.slides,
	        length = _state.length;
	
	    var index = slides.findIndex(function (_ref5) {
	      var id = _ref5.id;
	      return id === idToFind;
	    });
	
	    return index % length;
	  };
	
	  Gallery.prototype.getPreviousID = function getPreviousID() {
	    var slide = this.state.slides.find(function (_ref6) {
	      var previous = _ref6.previous;
	      return previous;
	    });
	
	    return slide ? slide.id : 0;
	  };
	
	  Gallery.prototype.init = function init() {
	    var slides = this.state.slides;
	    var id = slides[0].id;
	
	    var newSlides = slides;
	    newSlides = setActive(newSlides, id);
	    newSlides = setPrevious(newSlides, id);
	    this.setState({ slides: newSlides });
	  };
	
	  Gallery.prototype.handleClickToPrevious = function handleClickToPrevious() {
	    if (this.state.throttle) return;
	
	    var prevID = this.getActiveId();
	    var index = this.getArrayIndex(prevID);
	    var slides = this.state.slides;
	    var _slides = slides,
	        length = _slides.length;
	
	    var newIndex = index - 1;
	
	    if (newIndex < 0) {
	      newIndex = length - 1;
	    }
	
	    var id = this.state.slides[newIndex].id;
	
	
	    slides = setActive(slides, id);
	    slides = setPrevious(slides, prevID);
	
	    this.setState({ slides: slides });
	  };
	
	  Gallery.prototype.handleClickToNext = function handleClickToNext() {
	    if (this.state.throttle) return;
	
	    var prevID = this.getActiveId();
	    var index = this.getArrayIndex(prevID);
	    var slides = this.state.slides;
	    var _slides2 = slides,
	        length = _slides2.length;
	
	    var newIndex = index + 1;
	
	    if (length <= newIndex) {
	      newIndex = 0;
	    }
	
	    var id = this.state.slides[newIndex].id;
	
	
	    slides = setActive(slides, id);
	    slides = setPrevious(slides, prevID);
	
	    this.setState({ slides: slides });
	  };
	
	  Gallery.prototype.generateSlidesComponentsArray = function generateSlidesComponentsArray() {
	    var images = this.state.slides;
	
	    var activeID = this.getActiveId();
	    var slides = [];
	    var height = 0;
	
	    if (this.listWrapperRef.current) {
	      height = this.listWrapperRef.current.offsetHeight;
	    }
	
	    slides = images.map(function (_ref7) {
	      var id = _ref7.id,
	          title = _ref7.title,
	          image = _ref7.image;
	
	      var ref = _react2.default.createRef();
	      var active = activeID === id;
	      return _react2.default.createElement(_Slide2.default, {
	        title: title,
	        image: image,
	        key: id,
	        ref: ref,
	        height: height,
	        width: height * image.aspectRatio,
	        active: active
	      });
	    });
	
	    return slides;
	  };
	
	  Gallery.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state2 = this.state,
	        throttle = _state2.throttle,
	        length = _state2.length;
	    var title = this.props.title;
	
	    var activeID = this.getActiveId();
	    var caption = this.getDescription(activeID);
	    var position = this.getPositionById(activeID) + 1;
	    var slidesComponents = this.generateSlidesComponentsArray();
	    slidesComponents = equilibrate(slidesComponents, this.getArrayIndex(activeID));
	    var offsetWidthFromArray = getOffsetWidthFromArray(slidesComponents, activeID);
	    var width = 0;
	
	    if (this.listWrapperRef.current) {
	      width = this.listWrapperRef.current.offsetWidth;
	    }
	
	    var style = {
	      transform: 'translateX(-' + (offsetWidthFromArray - width) + 'px)',
	      transition: throttle ? 'transform 400ms' : 'none'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'gallery' },
	      _react2.default.createElement(
	        'p',
	        { className: 'gallery__title' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'gallery__list-wrapper', ref: this.listWrapperRef },
	        _react2.default.createElement(
	          'div',
	          { className: 'gallery__list', style: style },
	          slidesComponents
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'gallery__container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'gallery__count' },
	          position,
	          '/',
	          length
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'gallery__controller' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'gallery__control',
	              onClick: function onClick() {
	                return _this2.handleClickToPrevious();
	              }
	            },
	            '\u2039'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'gallery__control',
	              onClick: function onClick() {
	                return _this2.handleClickToNext();
	              }
	            },
	            '\u203A'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'gallery__caption' },
	          _react2.default.createElement(
	            'p',
	            null,
	            caption
	          )
	        )
	      )
	    );
	  };
	
	  return Gallery;
	}(_react.Component);
	
	Gallery.propTypes = {
	  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string
	  })).isRequired,
	  title: _propTypes2.default.string
	};
	
	Gallery.defaultProps = {
	  title: null
	};
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(15);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _rehypeReact = __webpack_require__(631);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ArticleList = __webpack_require__(28);
	
	var _ArticleList2 = _interopRequireDefault(_ArticleList);
	
	var _Gallery = __webpack_require__(140);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _PageTitle = __webpack_require__(16);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	__webpack_require__(619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // vendor
	
	
	// vendor components
	
	
	// utils
	
	
	// components
	
	
	// style
	
	
	var renderAst = new _rehypeReact2.default({
	  createElement: _react2.default.createElement
	}).Compiler;
	
	var galleryArrayConstructor = function galleryArrayConstructor() {
	  var gallery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return gallery.map(function (_ref) {
	    var id = _ref.id,
	        title = _ref.title,
	        description = _ref.description,
	        image = _ref.sizes;
	    return {
	      id: id,
	      title: title,
	      description: description,
	      image: image
	    };
	  });
	};
	
	var createGallery = function createGallery() {
	  var gallery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (gallery === null || gallery.length < 2) return null;
	
	  var galleryList = galleryArrayConstructor(gallery);
	  return _react2.default.createElement(_Gallery2.default, { images: galleryList, title: 'Galerie' });
	};
	
	var makeArticleList = function makeArticleList(list) {
	  return list.map(function (node) {
	    return {
	      thumbnail: {
	        sizes: node.hero.sizes,
	        alt: node.hero.title
	      },
	      date: node.publicationDate,
	      title: node.title,
	      excerpt: node.description.description,
	      id: node.id,
	      path: node.fields.path
	    };
	  });
	};
	
	var Article = function (_Component) {
	  _inherits(Article, _Component);
	
	  function Article(props) {
	    _classCallCheck(this, Article);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.article = props.data.article;
	    _this.site = props.data.site;
	    return _this;
	  }
	
	  Article.prototype.getGalleryItem = function getGalleryItem(position) {
	    var gallery = this.article.gallery;
	
	    return gallery && gallery.length > position ? gallery[position] : null;
	  };
	
	  Article.prototype.getHtmlAstPart = function getHtmlAstPart(partNumber) {
	    var htmlAst = _extends({}, this.article.body.childMarkdownRemark.htmlAst);
	    var firstPart = htmlAst.children.reduce(function (acc, cur) {
	      return acc.filter(function (el) {
	        return el.tagName === 'p';
	      }).length < 2 ? [].concat(acc, cur) : acc;
	    }, []);
	
	    if (partNumber === 1) {
	      htmlAst.children = firstPart;
	    } else {
	      htmlAst.children = htmlAst.children.slice(firstPart.length);
	    }
	
	    return htmlAst;
	  };
	
	  Article.prototype.getSubTitle = function getSubTitle() {
	    return this.article.country ? this.article.country.name : null;
	  };
	
	  Article.prototype.render = function render() {
	    var _article = this.article,
	        _article$gallery = _article.gallery,
	        gallery = _article$gallery === undefined ? [] : _article$gallery,
	        category = _article.category;
	    var _props$data = this.props.data,
	        firstRelatedArticles = _props$data.firstRelatedArticles,
	        secondRelatedArticles = _props$data.secondRelatedArticles,
	        thirdRelatedArticles = _props$data.thirdRelatedArticles;
	
	
	    var relateds = makeArticleList([firstRelatedArticles, secondRelatedArticles, thirdRelatedArticles]);
	
	    var firstImg = this.getGalleryItem(0);
	    var secondImg = this.getGalleryItem(1);
	
	    var heroIsBlue = category === 'Voyage';
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          this.article.title + ' | ' + this.site.siteMetadata.title
	        ),
	        _react2.default.createElement('meta', {
	          name: 'description',
	          content: this.article.description.description
	        }),
	        _react2.default.createElement('meta', { name: 'twitter:card', value: 'summary' }),
	        _react2.default.createElement('meta', {
	          property: 'og:title',
	          content: this.article.title + ' | Les coureurs des boires'
	        }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
	        _react2.default.createElement('meta', {
	          property: 'og:url',
	          content: 'https://www.lescoureursdesboires.com' + this.props.location.pathname
	        }),
	        _react2.default.createElement('meta', { property: 'og:image', content: this.article.hero.ogMeta.src }),
	        _react2.default.createElement('meta', {
	          property: 'og:description',
	          content: this.article.description.description
	        }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: 'Les coureurs des boires' }),
	        _react2.default.createElement('link', {
	          rel: 'canonical',
	          href: '' + this.site.siteMetadata.siteUrl + this.props.location.pathname
	        })
	      ),
	      _react2.default.createElement(_PageTitle2.default, {
	        title: this.article.category,
	        subTitle: this.getSubTitle(),
	        backgroundIsBlue: heroIsBlue
	      }),
	      _react2.default.createElement(
	        'article',
	        { className: 'article-page' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'article-page__title' },
	          this.article.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'article-page__part' },
	          firstImg && _react2.default.createElement(
	            'figure',
	            { className: 'article-page__part-image article-page__part-image--first' },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: firstImg.sizes, alt: firstImg.title }),
	            _react2.default.createElement(
	              'figcaption',
	              { className: 'article-page__part-image-caption' },
	              firstImg.description
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'article-page__first-part-text' },
	            renderAst(this.getHtmlAstPart(1))
	          )
	        ),
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: 'article-page__hero',
	          sizes: this.article.hero.sizes,
	          alt: this.article.hero.title
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'article-page__part' },
	          _react2.default.createElement(
	            'div',
	            { className: 'article-page__second-part-text' },
	            renderAst(this.getHtmlAstPart(2))
	          ),
	          secondImg && _react2.default.createElement(
	            'figure',
	            { className: 'article-page__part-image article-page__part-image--second' },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: secondImg.sizes, alt: secondImg.title }),
	            _react2.default.createElement(
	              'figcaption',
	              { className: 'article-page__part-image-caption' },
	              secondImg.description
	            )
	          )
	        )
	      ),
	      createGallery(gallery),
	      _react2.default.createElement(_ArticleList2.default, { articles: relateds, title: 'Articles li\xE9s' })
	    );
	  };
	
	  return Article;
	}(_react.Component);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	Article.propTypes = {
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        siteUrl: _propTypes2.default.string
	      })
	    }),
	    article: _propTypes2.default.shape({
	      title: _propTypes2.default.string,
	      category: _propTypes2.default.string,
	      body: _propTypes2.default.shape({
	        childMarkdownRemark: _propTypes2.default.shape({
	          html: _propTypes2.default.string
	        })
	      })
	    }),
	    firstRelatedArticles: _propTypes2.default.shape({
	      id: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      hero: _propTypes2.default.shape({
	        sizes: _propTypes2.default.object,
	        description: _propTypes2.default.string,
	        title: _propTypes2.default.string
	      }),
	      description: _propTypes2.default.shape({
	        description: _propTypes2.default.string
	      }),
	      publicationDate: _propTypes2.default.string,
	      fields: _propTypes2.default.shape({
	        path: _propTypes2.default.string
	      })
	    }),
	    secondRelatedArticles: _propTypes2.default.shape({
	      id: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      hero: _propTypes2.default.shape({
	        sizes: _propTypes2.default.object,
	        description: _propTypes2.default.string,
	        title: _propTypes2.default.string
	      }),
	      description: _propTypes2.default.shape({
	        description: _propTypes2.default.string
	      }),
	      publicationDate: _propTypes2.default.string,
	      fields: _propTypes2.default.shape({
	        path: _propTypes2.default.string
	      })
	    }),
	    thirdRelatedArticles: _propTypes2.default.shape({
	      id: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      hero: _propTypes2.default.shape({
	        sizes: _propTypes2.default.object,
	        description: _propTypes2.default.string,
	        title: _propTypes2.default.string
	      }),
	      description: _propTypes2.default.shape({
	        description: _propTypes2.default.string
	      }),
	      publicationDate: _propTypes2.default.string,
	      fields: _propTypes2.default.shape({
	        path: _propTypes2.default.string
	      })
	    })
	  }).isRequired,
	  location: _propTypes2.default.shape({
	    pathname: _propTypes2.default.string
	  }).isRequired
	};
	
	exports.default = Article;

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _randomString = __webpack_require__(159);
	
	var _randomString2 = _interopRequireDefault(_randomString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  randomString: _randomString2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
	
	  var outStr = '';
	  var newStr = '';
	  while (outStr.length < len) {
	    newStr = Math.random().toString(36).slice(2);
	    outStr += newStr.slice(0, Math.min(newStr.length, len - outStr.length));
	  }
	  return outStr;
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-index-jsx-08b9014f884c472cb6e9.js